import React from "react";
import { Link } from "react-router-dom";
import { createUseStyles } from "react-jss";
import { sendMetriks } from "Services/sendMetriks";
import PhoneContainerProvider from "Containers/PhoneContainerProvider";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";

const useStyles = createUseStyles((theme) => ({
	root: {},
	item: {
		// display: "flex",
		alignItems: "center",
		marginBottom: "10px",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	itemText: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: 1.29,
		letterSpacing: "2px",
		color: theme.palette.colors.white,
		textTransform: "uppercase",
		marginRight: "36px",
	},
	itemValue: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 1.25,
		color: theme.palette.colors.yellow,
	},
	partnersLink: {
		cursor: "pointer",
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 1.25,
		color: theme.palette.colors.yellow,
		borderBottom: `1px dashed ${theme.palette.colors.yellow}`,
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {},
		item: {
			marginBottom: "5px",
		},
		itemText: {
			fontSize: "14px",
			lineHeight: "1.5",
			letterSpacing: "1.7px",
		},
		itemValue: {
			lineHeight: 1.13,
		},
		partnersLink: {
			lineHeight: 1.13,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			textAlign: "center",
		},
		item: {
			marginBottom: "22px",
			flexWrap: "wrap",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		itemText: {
			fontSize: "12px",
			lineHeight: "1.5",
			letterSpacing: "1.7px",
			width: "100%",
			marginRight: 0,
		},
		itemValue: {
			lineHeight: 1.25,
			width: "100%",
		},
		partnersLink: {
			lineHeight: 1.25,
			width: "100%",
		},
	},
	description: {
		"& span": {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: 1.38,
			color: theme.palette.colors.white,
		},
		marginBottom: "10px",
	},
	description2: {
		"& span": {
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: 1.38,
			color: theme.palette.colors.white,
		},
	},
	href: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.38,
		color: theme.palette.colors.yellow,
		textTransform: "uppercase",
		textDecoration: "underline",
	},
}));

const OperatorBannerInfo = (props) => {
	const phoneClickHandler = () => {
		// Metrika.getInstance().google.sendEvent(
		//     EVENT_CATEGORY_CLICK_BUTTON,
		//     EVENT_ACTION_CLICK_COMPASSION_BUTTON_FAKE
		// );
		sendMetriks("CLICK_COMPASSION_PHONE_BUTTON_FAKE");
	};

	const partnersClickHandler = () => {
		window.open(props.link, "_blank");
	};

	const { text, h1After } = props;
	const soldToProvider = props.soldToProvider;
	const insinePhoneSupport = props.phoneSupport.replace(/[-()\s]/g, "");
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.item}>
				<div className={classes.itemText}>{text.SALES_DEPARTMENT}</div>
				{props.cardType === 3 ? (
					<span className={classes.partnersLink} onClick={partnersClickHandler}>
						{text.CONTACT_OPERATOR}
					</span>
				) : (
					<PhoneContainerProvider
						clickHandler={() => phoneClickHandler()}
						className={classes.itemValue}
						phone={props.phone}
					/>
				)}
			</div>
			{insinePhoneSupport && (
				<div className={classes.item}>
					<div className={classes.itemText}>{text.SUPPORT}</div>
					<a href={"tel:" + insinePhoneSupport} className={classes.itemValue}>
						{props.phoneSupport}
					</a>
				</div>
			)}
			{soldToProvider && (
				<div className={classes.description}>
					<span>
						{text.PROVIDER_SOLD_OUT}
						<Link
							className={classes.href}
							to={generateUrl(Routes.ProviderDetails.route, {
								providerName: soldToProvider.url_name,
								regionUrl: soldToProvider.region.url,
							})}
						>
							{soldToProvider.name}
						</Link>
					</span>
				</div>
			)}
			{h1After && (
				<div className={classes.description2}>
					<span itemProp="description">{h1After}</span>
				</div>
			)}
		</div>
	);
};

export default OperatorBannerInfo;
